import axios, { AxiosResponse } from "axios";
import { TrackJS } from "trackjs";

export class ExperimentService
{
	public AddTest = (thirdPartyTestID: string, variantSequence: number, callback?: Function): void =>
	{
		if (thirdPartyTestID !== undefined &&
			thirdPartyTestID !== null &&
			thirdPartyTestID.length > 0 &&
			variantSequence !== undefined &&
			variantSequence !== null && variantSequence > -1)
		{
			axios
				.post("/api/testvisitors/",
					{
						thirdPartyTestID: thirdPartyTestID,
						variantSequence: variantSequence
					})
				.then(function (response: AxiosResponse)
				{
					if (callback != null)
					{
						callback();
					}
				})
				.catch(function (error)
				{
					let statusCode = 0;

					if (error.response)
					{
						statusCode = error.response.status;
						console.log(`TrackJS API error: ${error.response.status}: ${error.response.data}`);
					}

					if (statusCode > 0)
					{
						// valid status code that we should handle (O means some sort of interruption)
						TrackJS.track("ExperimentSerivce error - API request");
					}
				});
		}
	};
}